import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import classes from "./Batafsil.module.css";
import classerror from "../../../shared/pages/Error404Page.module.css";
import Error404Animation from "../../../shared/assets/animated-placeholders/Error404.json";
import { useNavigate } from "react-router-dom";
import LottieView from "lottie-react";
import { testUrl } from "../BaseData";
import styles from "./newsClasses.module.css";
import moment from "moment";
import { InlineIcon } from "@iconify/react/dist/iconify.js";

const NewsDetails = () => {
    const { new_id } = useParams();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation(); // Access i18n instance
    const [new_data, setNew] = useState(null);
    const [relatedNews, setRelatedNews] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedIndex, setSelectedIndex] = useState(-1);


    useEffect(() => {
        setError(null);
        setLoading(true);
        const fetchNew = axios.get(
            testUrl + "/api/news/" + new_id
        );
        const fetchRelatedNews = axios.get(
            testUrl + "/api/news/"
        );

        Promise.all([fetchNew, fetchRelatedNews])
            .then(([newResponse, relatedResponse]) => {
                const responseData = newResponse.data;
                const relatedData = relatedResponse.data;
                if (responseData && relatedData) {
                    setNew(responseData);
                    // Filter out the current news and limit to 5 items
                    const filtered = relatedData.filter(news => news.id !== parseInt(new_id));
                    setRelatedNews(filtered.slice(0, 5));
                } else {
                    setError("Ma'lumotlar topilmadi");
                }
            })
            .catch(() => setError("Ma'lumotlarni yuklashda xatolik"))
            .finally(() => setLoading(false));
    }, [new_id, i18n.language]);



    const getNewTitle = (news) => {
        if (!news) return t("no_name_available");
        const title = news[`title_${i18n.language}`];
        return title || news.title_uz || t("no_name_available");
    };

    if (loading) return <p>Yuklanmoqda...</p>;

    // Add null check for new_data
    if (!new_data) {
        return <p>Yangilik ma'lumotlari topilmadi</p>;
    }

    if (error) return (
        <div className={classerror["error-page"]}>
            <LottieView className={classerror["animation"]}
                animationData={Error404Animation}
                loop={true}
            />
            <p className={classerror["title"]}>
                {t("sorry")}
            </p>
            <p className={classerror["description"]}>
                {t("back_main")}
            </p>
            <div onClick={() => navigate("/")} className={classerror["button"]}>
                {t("main_menu")}
            </div>
        </div>
    )

    const getImagesFromContent = (html) => {
        if (!html) return [];
        const imgRegex = /<img[^>]+src="([^">]+)"/g;
        const images = [];
        let match;
        while ((match = imgRegex.exec(html)) !== null) {
            images.push(match[1]);
        }
        return images;
    };

    const cleanContent = (html) => {
        if (!html) return "";
        // Remove img tags first as they are moved to gallery
        let cleaned = html.replace(/<img[^>]*>/g, "");

        // Only remove empty tags that are direct leftovers from image removal 
        // while preserving intentional spacing from the editor
        cleaned = cleaned.replace(/<(p|div|span)[^>]*>\s*<\/\1>/gi, "");

        return cleaned;
    };

    const contentLocale = new_data[`full_news_${i18n.language}`] || "";
    const contentImages = getImagesFromContent(contentLocale);

    // Combine new_data.image with images found in content
    const allImages = [];
    if (new_data.image && !new_data.image.includes('news.jpg')) {
        allImages.push(new_data.image);
    }

    contentImages.forEach(img => {
        if (!allImages.includes(img)) {
            allImages.push(img);
        }
    });

    const mainImage = allImages.length > 0 ? allImages[0] : null;
    const sliderImages = allImages.length > 1 ? allImages.slice(1) : [];

    const handleNext = (e) => {
        e.stopPropagation();
        setSelectedIndex((prev) => (prev + 1) % allImages.length);
    };

    const handlePrev = (e) => {
        e.stopPropagation();
        setSelectedIndex((prev) => (prev - 1 + allImages.length) % allImages.length);
    };

    return (
        <div className={classes.mainContainer}>
            <div className={classes.sidebar}>
                <h3 style={{ textAlign: 'left', borderBottom: '2px solid #133654' }}>
                    {t("Boshqa yangiliklar")}
                </h3>
                <ul style={{ listStyle: 'none', padding: 0 }}>
                    {relatedNews && relatedNews.length > 0 ? (
                        relatedNews.map((news) => (
                            <li
                                key={news.id}
                                onClick={() => navigate(`/news/${news.id}`)}
                                style={{
                                    marginBottom: '15px',
                                    cursor: 'pointer',
                                    background: '#ffffff',
                                    borderRadius: '8px',
                                    overflow: 'hidden',
                                    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.08)'
                                }}
                            >
                                <div style={{ padding: '12px' }}>
                                    <img
                                        src={news.image}
                                        alt={getNewTitle(news)}
                                        style={{
                                            width: '100%',
                                            height: '140px',
                                            objectFit: 'cover',
                                            borderRadius: '6px',
                                            marginBottom: '10px'
                                        }}
                                    />
                                    <h4 style={{
                                        margin: 0,
                                        fontSize: '14px',
                                        color: '#2c3e50',
                                        lineHeight: '1.5',
                                        fontWeight: '600',
                                        marginBottom: '8px'
                                    }}>
                                        {getNewTitle(news)}
                                    </h4>
                                    <span style={{
                                        fontSize: '12px',
                                        color: '#6c757d',
                                        display: 'block',
                                        fontWeight: '500'
                                    }}>
                                        {moment(news.posted_time)
                                            .locale(i18n.language)
                                            .format("DD-MMMM, HH:mm")}
                                    </span>
                                </div>
                            </li>
                        ))
                    ) : (
                        <li>{t("no_news_found")}</li>
                    )}
                </ul>
            </div>
            <div data-aos="fade-up" className={classes["rahbariyat-container"]}>
                <h1 className={classes["page-title"]} style={{ textAlign: 'left', borderBottom: 'none', fontSize: '28px' }}>
                    {new_data && new_data[`title_${i18n.language}`]}
                </h1>

                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    gap: '30px',
                    margin: '15px 0 25px 0',
                    color: '#666',
                    fontSize: '14px'
                }}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <InlineIcon icon="mdi:calendar" width="18" height="18" />
                        {moment(new_data.posted_time)
                            .locale(i18n.language)
                            .format("DD.MM.YYYY")}
                    </span>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <InlineIcon icon="mdi:eye" width="18" height="18" />
                        {new_data.view_count} {t("views")}
                    </span>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <InlineIcon icon="mdi:tag" width="18" height="18" />
                        {new_data.category?.[`name_${i18n.language}`] || new_data.category?.name_uz || ''}
                    </span>
                </div>

                <div className={classes.picholder}>
                    {mainImage && (
                        <div
                            className={classes.mainImageWrapper}
                            onClick={() => setSelectedIndex(0)}
                            style={{ cursor: 'zoom-in' }}
                        >
                            <img src={mainImage} alt="" className={classes.responsiveMainImg} />
                        </div>
                    )}
                </div>

                <div
                    className={`${classes.newsContent} ck-content`}
                    dangerouslySetInnerHTML={{
                        __html: cleanContent(contentLocale),
                    }}
                />

                {sliderImages.length > 0 && (
                    <div className={classes.sliderWrapper}>
                        <Swiper
                            spaceBetween={15}
                            slidesPerView={3}
                            loop={true}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            modules={[Autoplay, Pagination, Navigation]}
                            breakpoints={{
                                320: { slidesPerView: 1 },
                                576: { slidesPerView: 2 },
                                1024: { slidesPerView: 3 }
                            }}
                            className={classes.gallerySwiper}
                        >
                            {sliderImages.map((img, idx) => (
                                <SwiperSlide key={idx + 1}>
                                    <div
                                        className={classes.swiperImageCard}
                                        onClick={() => setSelectedIndex(idx + 1)}
                                    >
                                        <img src={img} alt="" className={classes.sliderImg} />
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                )}
            </div>

            {/* Image Modal Lightbox */}
            {selectedIndex !== -1 && (
                <div
                    className={classes.modalOverlay}
                    onClick={() => setSelectedIndex(-1)}
                >
                    <div className={classes.modalContent} onClick={(e) => e.stopPropagation()}>
                        <button
                            className={classes.closeModal}
                            onClick={() => setSelectedIndex(-1)}
                        >
                            <InlineIcon icon="mdi:close" width="30" height="30" />
                        </button>

                        {allImages.length > 1 && (
                            <>
                                <button className={classes.navBtn} style={{ left: '-60px' }} onClick={handlePrev}>
                                    <InlineIcon icon="mdi:chevron-left" width="40" height="40" />
                                </button>
                                <button className={classes.navBtn} style={{ right: '-60px' }} onClick={handleNext}>
                                    <InlineIcon icon="mdi:chevron-right" width="40" height="40" />
                                </button>
                            </>
                        )}

                        <img src={allImages[selectedIndex]} alt="Full view" className={classes.fullImage} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default NewsDetails;